export default function Breadcrumbs({ activeId }) {
  const breads = [
    { id: 1, label: "Home", active: activeId === 1 },
    { id: 3, label: "Park Details", active: activeId === 3 },
    { id: 4, label: "Checkout", active: activeId === 4 },
    { id: 5, label: "Payment", active: activeId === 5 },
  ];

  return (
    <div
      className="d-none d-lg-block"
      style={{ backgroundColor: "#108845", color: "white", padding: "12px" }}
    >
      <div className="d-flex container">
        {breads.map((bread, index) => (
          <div className="d-flex align-items-center" key={bread.id}>
            {bread.active ? (
              <p
                className="mb-0 mx-3 fw-bold"
                style={{
                  fontFamily: "Libre Franklin",
                  fontSize: "14px",
                }}
              >
                {bread.label}
              </p>
            ) : (
              <p
                className="mb-0 mx-3"
                style={{
                  fontFamily: "Libre Franklin",
                  fontSize: "14px",
                }}
              >
                {bread.label}
              </p>
            )}

            {index !== breads.length - 1 && <i className="fa fa-angle-right" />}
          </div>
        ))}
      </div>
    </div>
  );
}
